import { Tools } from "@comunicare/comunicare-helper";
import { AbstractHealthcareservice } from "@comunicare/comunicare-interfaces";

export class Healthcareservice extends AbstractHealthcareservice {
  protected capitalize(s: string): string {
    return Tools.capitalize(s);
  }
}
